import { axios } from '@/utils/request'

const api = {
  management: '/enterprise/management',
  prices: '/basicdata/prices',
  orderType: '/basicdata/orderType',
}

export function getPricesList (parameter) {
  return axios({
    url: api.prices + '/list',
    method: 'get',
    params: parameter
  })
}
export function getInfo (parameter) {
  return axios({
    url: api.prices + '/get/'+parameter,
    method: 'get',
  })
}

export function getOrderTypeList (parameter) {
  return axios({
    url: api.orderType + `/getList/${parameter}`,
    method: 'get',
  })
}

export function getOrderType (parameter) {
  return axios({
    url: api.orderType + '/getOrderType',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function save (parameter) {
  return axios({
    url: api.prices + '/save',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function update (parameter) {
  return axios({
    url: api.prices + '/update',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function delModel (parameter) {
  return axios({
    url: api.prices + '/remove',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

//禁用
export function pricesDisable (parameter) {
  return axios({
    url: api.prices + '/disable',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 企业
export function getSelectTree (parameter) {
  return axios({
    url: api.management + '/selectTree',
    method: 'get',
    params: parameter
  })
}

//添加 配置
export function insertEopList (parameter) {
  return axios({
    url: api.prices + '/insertEopList',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

//配置关联关系
export function selectEopList (parameter) {
  return axios({
    url: api.prices + `/selectEopList/${parameter}`,
    method: 'get',
  })
}

export const modelExport = api.model + '/export'
